<template>
  <div>
    <div v-if="isFixed" :style="{height: navHeight + 'px'}"></div>
    <div class="base_head">
      <div
        ref="navBar"
        class="flex-center navs"
        :class="{ fixedBar: isFixed }"
        :style="style"
      >
        <div class="flexs" style="z-index: 10000;" id="boxFixed">
          <div>
            <h1 class="logo-h1">云百科技</h1>
            <router-link to="/home"
              ><img
                class="logoImg"
                src="@img/logo.png"
                alt="云百科技"
                @click="getSqlCheck"
            /></router-link>
          </div>

          <div class="pos_r">
            <router-link
              v-for="(item, index) in list"
              :key="index"  
              :to="item.index == 1 ? '' : item.path"
              style="font-size: 16px;"
            >
              <div
                class="navitem"
                @click="select(index)"
                @mouseenter="mouseenter(index)"
                @mouseleave="mouseleave(index)"
                :class="[
                  activeIndex === item.index ? 'is-active' : '',
                  mouseIndex === index ? 'mou-active' : '',
                ]"
              >
                <span style="font-size: 16px;">{{ item.name }}</span>
                <div
                  v-if="index === 1 && mouseIndex === index"
                  class="mega-dropdown"
                  @mouseenter="mouseenter(index)"
                  @mouseleave="mouseleave(index)"
                >
                  <div class="mega-content">
                    <div class="left-section">
                      <div class="image-area">
                        <img
                          :src="currentMenuItem.image"
                          :alt="currentMenuItem.name"
                        />
                      </div>
                    </div>
                    <div class="center-section">
                      <div class="menu-section">
                        <div
                          class="menu-indicator"
                          :style="indicatorStyle"
                        ></div>
                          <router-link style="text-decoration: none;"  :to="currentMenuItem.path">
                        <div
                          v-for="(subItem, subIndex) in dropdownList"
                          :key="subIndex"
                          class="menu-item"
                          :class="{
                            'is-active': currentMenuIndex === subIndex,
                          }"
                          @mouseenter="handleMenuHover(subIndex)"
                          
                        >
                          <span>{{ subItem.name }}</span>
                          <i class="el-icon-arrow-right"></i>
                        </div>
                      </router-link>
                      </div>
                    </div>
                    <div class="right-section">
                      <div class="content-section">
                        <div class="text-area">
                          <h3>{{ currentMenuItem.title }}</h3>
                          <p>{{ currentMenuItem.description }}</p>
                          <div class="button-area">
                            <router-link
                              :to="currentMenuItem.path"
                              class="image-button"
                            >
                              <span class="liaojie" >了解更多</span>
                              <img class="jiantou" src="../../public/img/internet/Frame999.png" alt="">
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <!-- 动态组件区域 -->
      <component
        v-if="currentComponent"
        :is="currentComponent"
        class="dynamic-component"
      >
      </component>

      <!-- 轮播图 -->
  

      <!-- 二级菜单内容区域 -->
      <!-- <div v-if="showSubContent" class="sub-content">
        <div class="container">
          <div class="content-wrapper">
            <div class="text-content">
              <h2>{{ activeMenuItem.title }}</h2>
              <p>{{ activeMenuItem.description }}</p>
            </div>
            <div class="image-content">
              <img :src="activeMenuItem.image" :alt="activeMenuItem.title" />
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <!-- <div class="sideMenu" @click="messageHandle"> -->

    <div class="hoverMsg" @mouseleave="messageShow = false">
      <div
        class="message-box"
        :class="messageShow === true ? '' : 'visibility'"
      >
        <div class="online" style="cursor:pointer;" @click="isShow = true">
          <div class="message-div">
            <img src="@img/about/ic_zf_ly.png" />
            <h3>在线留言</h3>
          </div>
          <p>专属客户经理解答，提供专业的方案</p>
        </div>
        <div class="lineB"></div>
        <div class="online">
          <div class="message-div">
            <img src="@img/about/ic_zf_kf.png" />
            <h3>客服热线</h3>
          </div>
          <p>0769-89008900</p>
        </div>
      </div>
      <div class="sideMenu" @mouseover="messageShow = true">
        <img src="@img/about/ic_xfc_lx.png" />
        <span>联系我们</span>
      </div>
    </div>
    <scroll-top class="backTop"></scroll-top>
    <plan-dialog
      :isShow="isShow"
      v-if="isShow"
      @closeTop="closeTop"
    ></plan-dialog>
  </div>
</template>
<script>
import planDialog from "../components/planDialog.vue";

import solution from "@components/solution.vue";
import mixin from "@/mixin/index.js";
// import SmartProducts from "@/pages/internet/smartproducts.vue";
// import GlobalConnection from "@/pages/internest/global-connection.vue";
// import Solutions from "@/pages/internet/solutions.vue";

export default {
  name: 'Head',
  mixins: [mixin],
  components: {
    planDialog,
    // solution,
    // SmartProducts,
    // GlobalConnection,
    // Solutions,
  },
  props: {
    bannerData: {
      type: [Array],
      default: () => [],
    },
    active: {
      type: [Number, String],
      default: 0,
    },
    isBanner: {
      type: [Boolean],
      default: true,
    },
    isGif: {
      type: [Boolean],
      default: true,
    },
    bannerLists: {
      type: [Array],
      default: () => [],
    },
    color: {
      type: [String],
      default: "black",
    },
    textColor: {
      type: [String],
      default: "black",
    },
    indicator: {
      type: [String],
      default: "",
    },
  },
  data() {
    return {
      isShow:false,
      dynamicImg: require("@assets/dynamic_banner.gif"),
      count: 0,
      messageShow: false,
      // slideShows:false,
      isShow: false,
      activeIndex1: null,
      bannerDatas: this.bannerData,
      activeIndex: this.active,
      mouseIndex: this.active,
      isBanners: this.isBanner,
      isGifs: this.isGif,
      imgHeight: "",
      solutionShow: false,
      list: [
        {
          path: "/home",
          name: "首页",
          index: 0,
        },
        {
          path: "/",
          name: "智能网联",
          index: 1,
        },
        // {
        //   path: "/serve",
        //   name: "物联网",
        //   index: 2,
        // },
        {
          path: "/intelligentize",
          name: "数智化",
          index: 3,
        },
        {
          path: "/software",
          name: "软件研发",
          index: 4,
        },
        {
          path: "/economy",
          name: "低空经济",
          index: 5,
        },
        // {
        //   path: '/indusAuto',
        //   name: '工业数字化',
        //   index: 2
        // },
        //  {
        //   path: '/info',
        //   name: '招标公告',
        //   index: 4
        //  },
        {
          path: "/aboutUs",
          name: "关于我们",
          index: 6,
        },
        // {
        //   path: '/solution',
        //   name: '解决方案',
        //   index: '4'
        // },
        // {
        //   path: '/info',
        //   name: '信息中心',
        //   index: '4'
        // },
      ],

      serviceList: [
        {
          img: require("@img/home/ic_solution0.png"),
          title: "定制专属方案",
        },
        {
          img: require("@img/home/ic_solution1.png"),
          title: "免费备案",
        },
        {
          img: require("@img/home/ic_solution2.png"),
          title: "1个工作日内排除故障",
        },
        {
          img: require("@img/home/ic_solution3.png"),
          title: "1V1专业客服",
        },
        {
          img: require("@img/home/ic_solution4.png"),
          title: "7×24小时服务",
        },
      ],
      bannerList: this.bannerLists,
      // color:'black',
      // color:'white',
      isFixed: false,
      style: {},
      opacity: 0,
      currentMenuIndex: 0,
      dropdownList: [
        {
          name: "车联网",
          path: "/carnetwork",
          image: require("@img/internet/product.png"),
          title: "车联网",
          description:
            "提供180+国家和地区车网联服务，整合和智能分析车联网数据，打造定制化流量运营平台，精细化流量监测和管理，优化成本和使用效率，拓展车联网B2B模式和B2B2C模式，满足车企和车主多样化流量使用需求。",
        },
        {
          name: "智联产品",
          path: "/smartproducts",
          image: require("@img/internet/solution.png"),
          title: "智联产品",
          description:
            "云百为行业客户提供定制化的智联网产品及服务方案。\n工业级智能网关及DTU系列产品采用稳定可靠的通信模组，支持全球运营商网络，实现串口与4G Cat.1(WiFi可选)互传。\n应用场景：智慧路灯、远程监控、智慧农业、热泵空调、电网、交通、消防、工业生产、气象环境、农林、矿产",
        },
        {
          name: "全球链接",
          path: "/globalconnection",
          image: require("@img/internet/case.png"),
          title: "全球链接",
          description:
            "云百应用eSIM、VSIM技术给客户提供全球网络连接服务，保障客户出海业务顺利开展，赋能客户快速实现全球化无缝部署。",
        },
        {
          name: "解决方案",
          path: "/solutions",
          image: require("@img/internet/solutions.png"),
          title: "解决方案",
          description:
            "云百智能网联解决方案将人工智能与物联网技术相互融合，通过将传感器、设备、机器等连接到互联网，实现数据的实时收集、传输、处理、大数据分析和应用，提升行业应用的自动化水平，优化业务决策过程，增强终端用户使用体验。",
        },
      ],
      showCarousel: true,
      currentContent: null,
      isInternetActive: false,
      currentComponent: null,
      componentMap: {
        // "/car-network": "CarNetwork",
        // "/smart-products": "SmartProducts",
        // "/global-connection": "GlobalConnection",
        // "/solutions": "Solutions",
      },
      showSubContent: false,
      activeMenuItem: null,
      menuHideTimer: null,
      navHeight: 0,
    };
  },
  computed: {
    currentMenuItem() {
      return this.dropdownList[this.currentMenuIndex] || this.dropdownList[0];
    },
    indicatorStyle() {
      const itemHeight = 40; // 菜单项高度
      const itemMargin = 6;  // 菜单项间距
      const totalHeight = itemHeight + itemMargin;
      
      return {
        transform: `translateY(${this.currentMenuIndex * totalHeight}px)`,
        opacity: this.mouseIndex === 1 ? '1' : '0',
        height: `${itemHeight}px`,
        top: '0',
        transition: 'transform 0.3s cubic-bezier(0.3, 0, 0.2, 1)'
      };
    },
    shouldShowCarousel() {
      // 在二级菜单页面不显示轮播图
      const path = this.$route.path;
      return ![
        // "/carnetwork",
        // "/smartproducts",
        // "/globalconnection",
        // "/solutions",
      ].includes(path);
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        // 根据当前路由更新菜单高亮状态
        const currentPath = to.path;
        const menuIndex = this.dropdownList.findIndex(item => item.path === currentPath);
        if (menuIndex !== -1) {
          this.currentMenuIndex = menuIndex;
          this.activeIndex = 1; // 保持"智能网联"菜单激活
          this.showSubContent = true;
          this.activeMenuItem = this.dropdownList[menuIndex];
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.navHeight = this.$refs.navBar.offsetHeight;
      window.addEventListener("resize", this.updateNavHeight);
    });
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    btnclk() {
      this.isShow = true;
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; // 滚动条偏移量
      this.isFixed = scrollTop > 60;
    },
    messageHandle() {
      this.messageShow = !this.messageShow;
    },
    closeTop() {
      this.isShow = false;
    },
    select(index) {
      if (index !== 1) {
        this.showSubContent = false;
        this.activeMenuItem = null;
        let paths = this.list[index].path;
        this.$router.push({ path: paths });
      }
    },
    mouseenter(index) {
      this.mouseIndex = index;
      if (this.menuHideTimer) {
        clearTimeout(this.menuHideTimer);
        this.menuHideTimer = null;
      }
      if (index === 1) {
        this.addFrostedGlass();
        this.showLocalBackdropGlass();
      }
    },
    mouseleave(index) {
      if (index === 1) {
        this.hideLocalBackdropGlass(); // 立刻隐藏毛玻璃

        this.menuHideTimer = setTimeout(() => {
          this.mouseIndex = "";
        }, 100);
      } else {
        this.mouseIndex = "";
      }
    },
    mouseenter1(index) {
      this.activeIndex1 = index;
    },
    mouseleave1() {
      this.activeIndex1 = "";
    },
    goBanPath(path) {
      if (!path) return;
      this.$router.push({path} );
      console.log(path,78);
      this.mouseIndex = ""; // 关闭下拉菜单
    },
    getSqlCheck() {
      this.$router.push({ path: "/home" });
      if (this.count === 0) {
        this.startTime = new Date();
        this.lastTime = this.startTime;
      } else if (this.count >= 1) {
        let nextTime = new Date();
        if (nextTime - this.startTime >= 1500) {
          // 超过五秒重置
          this.startTime = nextTime;
          this.lastTime = nextTime;
          this.count = 0;
        } else {
          this.lastTime = nextTime;
        }
        if (this.count === 5) {
          // 大于三次重置
          this.sqlCheck(true);
          this.startTime = nextTime;
          this.lastTime = nextTime;
          this.count = 0;
        }
      }
      this.count++;
      // console.log(this.count);
    },
    sqlCheck(flag) {
      console.log(flag);
      this.$router.push({ path: "/test" });
    },
    handleMenuHover(index) {
      this.currentMenuIndex = index;
      this.activeMenuItem = this.dropdownList[index];
    },
    handleContentSwitch(item) {
      this.showSubContent = true;
      this.activeMenuItem = item;
      this.activeIndex = 1; // 保持"智能网联"菜单激活状态
    },
    addFrostedGlass() {
      this.$nextTick(() => {
        const dropdown = this.$el.querySelector('.mega-dropdown');
        if (dropdown && !dropdown.querySelector('.frosted-bg')) {
          const frosted = document.createElement('div');
          frosted.className = 'frosted-bg';
          Object.assign(frosted.style, {
            position: 'absolute',
            inset: '0',
            zIndex: 0,
            background: 'rgba(255,255,255,0.6)',
            backdropFilter: 'blur(16px)',
            WebkitBackdropFilter: 'blur(16px)',
            pointerEvents: 'none'
          });
          dropdown.insertBefore(frosted, dropdown.firstChild);
        }
      });
    },
    showLocalBackdropGlass() {
      this.$nextTick(() => {
        const content = this.$el.querySelector('.mega-content');
        if (!content) return;
        const rect = content.getBoundingClientRect();
        let frosted = document.getElementById('global-frosted-bg');
        if (!frosted) {
          frosted = document.createElement('div');
          frosted.id = 'global-frosted-bg';
          document.body.appendChild(frosted);
        }
        Object.assign(frosted.style, {
          position: 'fixed',
          left: rect.left + 'px',
          top: rect.top + 'px',
          width: rect.width + 'px',
          height: rect.height + 'px',
          zIndex: 999,
          background: 'rgba(255,255,255,0.3)',
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)',
          pointerEvents: 'none',
          borderRadius: window.getComputedStyle(content).borderRadius || '0px',
          transition: 'opacity 0.2s',
          opacity: 1
        });
      });
    },
    hideLocalBackdropGlass() {
      const frosted = document.getElementById('global-frosted-bg');
      if (frosted) frosted.style.opacity = 0;
      setTimeout(() => {
        if (frosted && frosted.parentNode) frosted.parentNode.removeChild(frosted);
      }, 200);
    },
    updateNavHeight() {
      this.navHeight = this.$refs.navBar.offsetHeight;
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); // 离开页面 关闭监听 不然会报错
    window.removeEventListener("resize", this.updateNavHeight);
  },
};
</script>

<style lang="scss" scoped>
// .el-tabs__nav-wrap::after {
//   height: 1px;
// }
// .sideMenu:hover .message-box{
//   background: #f00;
//   display: block;
// }
.backTop {
  bottom: 100px !important;
  right: 24px !important;
  width: 44px;
  height: 44px;
  background: linear-gradient(180deg, #f2f5fa, #fefefe);
  border: 2px solid #ffffff;
  border-radius: 4px;
  box-shadow: 2px 6px 10px #59585814;
  i {
    font-size: 24px;
  }
  :deep(.el-icon-caret-top) {
    font-size: 24px;
  }
} 
.solutions {
  position: fixed;
  width: 100%;
  top: 80px;
  z-index: 99;
}
//头部
.base_head {
  z-index: 1000;
  position: relative;
  height: auto;
  //导航栏起始
  .flex-center {
    display: flex;
    justify-content: center;
  }
  .flexs {
    display: flex;
    width: 1400px;
    margin: 0 auto;
    align-items: center;
    justify-content: space-between;
  }

  .logo-h1 {
    display: none;
  }
  .navs {
    background: #ffffff;
    backdrop-filter: blur(16px);
    position: relative;
    z-index: 99;
    width: 100%;
  }
  .logoImg {
    width: 132px;
    height: 32px;
    opacity: 1;
    cursor: pointer;
  }
  .fixedBar {
    position: fixed !important;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    background: #ffffff;
    box-shadow: 2px 6px 10px #59585814;
  }

  .navitem {
    margin-left: 48px;
    // height: 60px;
    text-align: center;
    line-height: 64px;
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    color: #4d4d4d;
    cursor: pointer;
    .router-link {
      span {
        font-size: 16px !important;
      }
    }
  }
  ::v-deep .navitem.is-active {
    font-size: 16px !important;
    font-weight: 700;
    color: #1e77ec !important;
    position: relative;
  }
  .navitem.is-active {
    font-size: 16px !important;
    font-weight: 700;
    color: #1e77ec !important;
    position: relative;
  }
  .navitem.mou-active {
    font-size: 16px;
    font-weight: 700;
    color: #1e77ec !important;
    position: relative;
  }
  //导航栏结束

  //轮播图起始
  .el-carousel {
    height: 544px;
    overflow: hidden;
    .el-carousel__container {
      height: 544px;
    }
    ::v-deep .el-carousel__container {
      height: 100%;
    }
  }
  .margin-banner {
    margin-top: 80px !important;
  }
  //申请试用按钮
  .apply-button {
    margin-top: 90px;
    width: 136px;
    height: 44px;
    background: #0063e6;
    border-radius: 4px;
    font-weight: 400;
    color: #ffffff;
    font-size: 16px;
    border: none;
    cursor: pointer;
    
  }

  .el-carousel {
    height: 550px;
    .el-carousel__container {
      height: 544px;
    }
  }

  .el-carousel__indicators {
    bottom: 102px;
    li {
      width: 47px;
      height: 3px;
      opacity: 0.38;
      background: #ffffff;
      border-radius: 2px;
      padding: 0;
      margin: 0 4px;
      background: #2b4fc7;
      border-radius: 1px;
      .el-carousel__button {
        width: auto;
        height: auto;
      }
    }
    .el-carousel__indicator.is-active {
      opacity: 1;
      background: #1e77ec;
      button {
        width: auto;
        height: auto;
      }
    }
  }

  .img_box {
    width: 100%;
    .banner_item {
      color: #475669;
      font-size: 18px;
      opacity: 0.75;
      line-height: 420px;
      margin: 0;
      height: 420px;
    }
  }
  //轮播图样式
  .banners {
    background: url("../../public/img/banner_iot_a_bg.png") no-repeat;
    //  background: linear-gradient(90deg,#f7f9fc, #f9f9f9);
    position: relative;
    background-size: 100% 100%;
    height: 500px;
    position: absolute;
    width: 100%;
    .dynamic-img {
      width: 420px;
      text-align: right;
      margin-top: 5px;
    }
    .LOT-title {
      font-size: 40px;
      font-weight: 600;
      margin-top: 99px;
      text-align: left;
      font-family: PingFang SC, PingFang SC-500;
    }
  }
  .UAV_ai {
    background: url("../../public/img/economy/economy-banner-bg.png") no-repeat;
    //  background: linear-gradient(90deg,#f7f9fc, #f9f9f9);
    position: relative;
    background-size: 100% 100%;
    height: 500px;
    position: absolute;
    width: 100%;
    .dynamic-img {
      width: 420px;
      text-align: right;
      margin-top: 5px;
    }
    .LOT-title {
      font-size: 50px;
      font-weight: 600;
      margin-top: 50px;
      text-align: left;
      color: #0c1152;
      font-family: PingFang SC, PingFang SC-500;
    }
    .LOT-in {
      margin-top: 16px;
      color: #0c1152;
      width: 590px;
      height: 52px;
      font-size: 18px;
      font-weight: 400;
      text-align: left;
      line-height: 28px;
    }
  }
  .economy {
    background: url("../../public/img/economy/economy-banner1.jpg") no-repeat;
    //  background: linear-gradient(90deg,#f7f9fc, #f9f9f9);
    position: relative;
    background-size: 100% 100%;
    height: 500px;
    position: absolute;
    width: 100%;
    .dynamic-img {
      width: 420px;
      text-align: right;
      margin-top: 5px;
    }
    .LOT-title {
      font-size: 50px;
      font-weight: 600;
      margin-top: 99px;
      text-align: left;
      color: #0c1152;
      font-family: PingFang SC, PingFang SC-500;
    }
    .LOT-in {
      margin-top: 16px;
      color: #0c1152;
      width: 570px;
      height: 52px;
      font-size: 30px;
      font-weight: 400;
      text-align: left;
      line-height: 28px;
    }
  }
  .banners1 {
    background: radial-gradient(#daf3fb, #c2dee6);
    height: 500px;
    position: absolute;
    width: 100%;
    .dynamic-img {
      width: 420px;
      text-align: right;
      margin-top: -40px;
    }
    .LOT-title {
      font-size: 40px;
      font-weight: 600;
      margin-top: 99px;
      text-align: left;
      font-family: PingFang SC, PingFang SC-500;
    }
  }
  .banners2 {
    background: url("../../public/img/about/banner_gywm.png");
    position: absolute;
    width: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 500px;
    .LOT-title {
      font-size: 40px;
      font-weight: 600;
      margin-top: 40px;
      text-align: left;
      font-family: PingFang SC, PingFang SC-500;
    }
  }
  .banners3 {
    background: url("../../public/img/solution/img_jjfa.png");
    position: absolute;
    width: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 500px;
    .LOT-title {
      font-size: 40px;
      font-weight: 600;
      margin-top: 48px;
      text-align: left;
      font-family: PingFang SC, PingFang SC-500;
    }
  }
  .home_bg1 {
    background: url("../../public/img/home/home_bg1.png");
    position: absolute;
    width: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 500px;
    .LOT-title {
      font-size: 40px;
      font-weight: 600;
      margin-top: 48px;
      text-align: left;
      font-family: PingFang SC, PingFang SC-500;
    }
    img {
      margin-top: 40px;
    }
  }
  .indusAuto_bg {
    background: url("../../public/img/indusAuto/indusAuto_bg.png");
    position: absolute;
    width: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 500px;
    .LOT-title {
      font-size: 40px;
      font-weight: 600;
      margin-top: 48px;
      text-align: left;
      font-family: PingFang SC, PingFang SC-500;
    }
    img {
      margin-top: 40px;
    }
  }
  .indusAuto_bg1 {
    background: url("../../public/img/indusAuto/indusAuto_bg.png");
    position: absolute;
    width: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 500px;
    .LOT-title {
      font-size: 40px;
      font-weight: 600;
      margin-top: 48px;
      text-align: left;
      font-family: PingFang SC, PingFang SC-500;
    }
    img {
      display: none;
    }
  }
  .about_bg {
    background: url("../../public/img/about/about_bg.png");
    position: absolute;
    width: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 500px;
    .LOT-title {
      font-size: 40px;
      font-weight: 600;
      margin-top: 48px;
      text-align: left;
      font-family: PingFang SC, PingFang SC-500;
    }
  }
  .serve_bg {
    background: url("../../public/img/about/serve_bg.png");
    position: absolute;
    width: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 500px;
    .LOT-title {
      font-size: 40px;
      font-weight: 600;
      margin-top: 48px;
      text-align: left;
      font-family: PingFang SC, PingFang SC-500;
    }
    img {
      width: 400px;
    }
  }
  .LOT-in {
    margin-top: 16px;
    color: #6e747a;
    width: 565px;
    height: 52px;
    font-size: 24px;
    font-weight: 400;
    text-align: left;
    line-height: 28px;
  }
  //轮播图结束

  //五大服务
  .service {
    z-index: 99;
    background-color: #fff;
    width: 1200px;
    height: 88px;
    line-height: 88px;
    margin: 0 auto;
    bottom: 0px;
    left: 50%;
    margin-left: -600px;
    position: absolute;
    border: 1px solid #ffffff;
    border-radius: 4px;
    box-shadow: 0px 3px 14px 0px #e4e9f2;
    ul {
      display: flex;
      justify-content: space-around;
      img {
        vertical-align: middle;
      }
      span {
        margin-left: 8px;
      }
      li {
        width: 100%;
        position: relative;
        .lineB {
          display: none;
          opacity: 1;
          position: absolute;
          background: #1e77ec;
          bottom: 0px;
          width: 100%;
          height: 2px;
        }
      }
      li.partnerActive {
        transform: scale(1.3) !important;
        z-index: 11;
      }
    }
  }
}
.hoverMsg {
  position: fixed;
  bottom: 160px;
  right: 24px;
  z-index: 999;
  display: flex;
  align-items: flex-end;
}
.visibility {
  visibility: hidden;
}
.sideMenu:hover,
.message-box:hover {
  box-shadow: 8px 8px 24px 0px rgb(0 55 128 / 16%);
  transition: all 0.3s cubic-bezier(0, 0, 0.5, 1);
}

//联系我们
.sideMenu {
  margin-top: 10px;
  width: 44px;
  bottom: 160px;
  height: 118px;
  background: linear-gradient(180deg, #f2f5fa, #fefefe);
  border: 2px solid #ffffff;
  border-radius: 4px;
  box-shadow: 2px 6px 10px #59585814;
  // position: fixed;
  right: 24px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  z-index: 999;
  cursor: pointer;
  span {
    width: 14px;
    font-size: 14px;
    font-weight: 400;
    color: #0063e6;
    line-height: 18px;
  }
}
//在线留言
.message-box {
  margin-top: 10px;
  // display: none;
  width: 293px;
  height: 145px;
  background: linear-gradient(180deg, #f2f5fa, #fefefe);
  border: 2px solid #ffffff;
  border-radius: 4px;
  box-shadow: 0px 3px 14px 0px #e4e9f2;
  position: relative;
  // right: 80px;
  z-index: 999;
  text-align: left;

  bottom: -27px;
  margin-right: 20px;
  .lineB {
    // background: #98a3af;
    // height: 1px;
    // width: 290px;
    background: #dcdee1;
    height: 1px;
    width: 100%;
    // margin-left: 41px;
  }
  .online {
    padding: 16px 0 15px 13px;
    h3 {
      display: inline-block;
      margin-left: 13px;
      font-size: 16px;
      font-weight: 400;
    }
    img {
      margin-left: 5px;
    }
    p {
      color: #98a3af;
      margin-left: 39px;
    }
  }
}

//页面的公共样式
.tab-padding {
  overflow: hidden;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 8px 24px 0px rgba(155, 178, 212, 0.23);
  .el-tabs {
    margin: 12px 24px 24px;
  }
}
.main-bottom {
  padding-bottom: 78px !important;
}

.bg-box {
  background: linear-gradient(180deg, #f3f5f8, #fefefe);
  border: 2px solid #ffffff;
  border-radius: 4px;
  box-shadow: 0px 3px 14px 0px #f0f3f8;
}

.el-row {
  padding: 10px 0 40px;
}
//tab选项卡
.el-tabs__item.is-active {
  font-weight: 700;
  text-align: center;
  color: #161719;
}
//tab选项卡的下划线颜色
.el-tabs__active-bar {
  background: linear-gradient(90deg, #0063e6, #9cc6fe);
}
.el-tabs__header {
  margin-bottom: 30px;
}
:deep(.base_head .el-carousel__indicators li) {
  width: 32px;
}
.base_head .el-carousel__indicators li {
  width: 32px;
}
.is-active {
  font-size: 16px;
  font-weight: 700;
  color: #1e77ec !important;
  position: relative;
}

.mega-dropdown, .mega-content {
  z-index: 1000 !important;
  position: relative;
}

.mega-dropdown {
  opacity: 0.8;
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  width: 100%;


  z-index: 1000;
  transition: opacity 0.3s ease;
  background: url("../../public/img/internet/选项卡底部背景.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background: rgba(249,249,249,0.99);
  backdrop-filter: blur(30px);
}

.mega-content {
  display: flex;
  align-items: stretch;
  min-height: 280px;
  position: relative;
  width: 100%;
  background: #fff;
  padding-left: 130px;
}

.left-section {
  width: 30%;
  position: relative;
  overflow: hidden;
  padding-top: 20px;
}

.image-area {
  width: 100%;
  height: 220px;
  overflow: hidden;
  position: relative;
  left: 120px;
  top: 0;

  img {
    width: 340px;
    height: 220px;
    object-fit: cover;
    display: block;
    padding-left: 50px;
  }
}

.center-section {
  width: auto;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: -100px 0 32px 40px;
  background: transparent;
  margin-top: -16px;
}

.menu-section {
  width: 160px;
  position: relative;
  padding-right: 4px;
}

.menu-item,
.menu-item:hover,
.menu-item:active,
.menu-item:focus,
.menu-item a,
.menu-item a:hover,
.menu-item a:active,
.menu-item a:focus {
  text-decoration: none !important;
}

.menu-item {
  height: 40px;
  padding: 0 16px;
  font-size: 15px;
  color: rgba(77, 77, 77, 0.9);
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s;
  margin-bottom: 6px;
  position: relative;
  border-radius: 4px;

  &::after {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    width: 3px;
    height: 100%;
    background: #1e77ec;
    border-radius: 2px;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &.is-active {
    color: #1e77ec;
    font-weight: 800;
    background: rgba(30, 119, 236, 0.05);

    &::after {
      opacity: 1;
    }
  }

  &:hover {
    color: #1e77ec;
    background: rgba(30, 119, 236, 0.05);

    &::after {
      opacity: 1;
    }
  }

  span {
    position: relative;
    z-index: 1;
  }

  i {
    font-size: 12px;
    opacity: 0.5;
    transition: all 0.3s ease;
    margin-left: 4px;
  }

  &:hover i {
    opacity: 1;
    color: #1e77ec;
    transform: translateX(2px);
  }
}

.right-section {
  flex: 1;
  padding: 20px 40px 32px 30px;
  display: flex;
  align-items: flex-start;
  background: transparent;
}

.content-section {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.text-area {
  text-align: left;
  max-width: 580px;
  margin-top: 0;

  h3 {
    font-size: 28px;
    color: #333;
    margin: 0 0 16px;
    font-weight: 600;
    line-height: 1.2;
    text-align: left;
    padding-top: 0;
  }

  p {
    font-size: 13px;
    line-height: 1.8;
    color: rgba(102, 102, 102, 0.9);
    margin: 0 0 20px;
    opacity: 0.9;
    font-weight: 300;
  }
}

.button-area {
  margin-top: auto;
  padding-top: 20px;
}

.image-button {
  display: inline-flex;
  align-items: center;
  padding: 0 24px;
  height: 44px;
  background: #1e77ec;
  background-image: linear-gradient(135deg, #1e77ec 0%, #4a90e2 100%);
  border-radius: 22px;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(30, 119, 236, 0.2);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(30, 119, 236, 0.3);
  }

  span {
    color: #ffffff;
    font-size: 16px;
    font-weight: 800;
  }

  i {
    margin-left: 8px;
    color: #ffffff;
    font-size: 14px;
    transition: transform 0.3s ease;
  }

  &:hover i {
    transform: translateX(3px);
  }
}

.features {
  display: none;
}

.navitem {
  position: relative;
}

.main-content {
  padding-top: 64px;
  background: #fff;
  min-height: calc(100vh - 64px);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.content-wrapper {
  display: flex;
  align-items: center;
  gap: 60px;
  min-height: 320px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
}

.text-content {
  flex: 1;
  padding-right: 40px;

  h2 {
    font-size: 36px;
    color: #333;
    margin-bottom: 30px;
    font-weight: 600;
  }

  p {
    font-size: 16px;
    line-height: 1.8;
    color: #666;
    margin-bottom: 30px;
    white-space: pre-wrap;
  }
}

.image-content {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 500px;
  height: 320px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 8px;
  }
}

.dynamic-component {
  padding-top: 64px; // 为导航栏留出空间
  min-height: calc(100vh - 64px);
  background: #fff;
}

.sub-content {
  padding-top: 64px;
  background: #fff;
  min-height: calc(100vh - 64px);
}
.jiantou{
  width: 28px;
  height: 28px;
  margin-left: 10px;
}
.liaojie{
  font-weight: 400;
}
.apply-button:hover {
  background: #0041E6;
  color: #fff;
}
.LOT-title, .LOT-title1, .LOT-title2, h3 {
  font-weight: 600 !important;
  font-family: PingFang SC, PingFang SC-500;
}
</style>
